module.exports = __webpack_public_path__ + "media/college_jobs_internships/cta_stacked-5038d816.png";